"use client";
import ThemeToggle from "@/components/common/darkMode/ThemeToggle";
import Image from "next/image";
import Link from "next/link";

export default function NotFound() {
  return (
    <>
      <div className="min-h-screen flex flex-col items-center justify-center text-center py-8 lg:py-12">
        <div className="max-w-[700px]">
          <div className="image-wrap relative md:w-[449px] w-[330px] md:h-[300px] h-[210px] mx-auto">
            <Image
              src={"/images/error-404.png"}
              alt="Not Found (404)"
              className="error-image"
              fill
            />
          </div>

          <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl !font-bold text-primary-text font-heading !mt-12 md:mb-6 mb-3">
            Oops! আমরা এই পাতাটি খুঁজে পাচ্ছি না!
          </h1>
          <p className="text-xl lg:text-2xl xl:text-3xl text-paragraph-text font-heading font-medium">
            যে পাতাটি আপনি খুঁজছেন, তা আর এখানে নেই।
          </p>
          <Link href="/" className="primary-btn  !inline-block md:mt-6 mt-3">
            হোম পেজ ফিরে যান
          </Link>
        </div>
      </div>
    </>
  );
}
